import { createContext, useContext, useState, useEffect } from 'react';

const EnvironmentContext = createContext();

export const useEnvironment = () => {
    const context = useContext(EnvironmentContext);
    if (context === undefined) {
        throw new Error('useEnvironment must be used within an EnvironmentProvider');
    }
    return context;
};

export const EnvironmentProvider = ({ children }) => {
    const [environment, setEnvironment] = useState(() => {
        const savedEnv = window.localStorage.getItem('firebase-env');
        return savedEnv || 'production';
    });

    useEffect(() => {
        window.localStorage.setItem('firebase-env', environment);
    }, [environment]);

    const changeEnvironment = (newEnv) => {
        if (newEnv === 'development' || newEnv === 'production') {
            setEnvironment(newEnv);
        }
    };

    return (
        <EnvironmentContext.Provider value={{ environment, changeEnvironment }}>
            {children}
        </EnvironmentContext.Provider>
    );
};